import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import requestAnimationFrame from '../bom/requestAnimationFrame';
/**
 * 等待一段时间，返回一个promise
 * @default 25
 * @param delayTimeMs
 * @param value
 * @category Promise
 */

function delay(_x, _x2) {
  return _delay.apply(this, arguments);
}

function _delay() {
  _delay = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(delayTime, value) {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!(delayTime <= 17)) {
              _context.next = 2;
              break;
            }

            return _context.abrupt("return", new Promise(function (resolve) {
              return requestAnimationFrame(function () {
                return resolve();
              });
            }));

          case 2:
            return _context.abrupt("return", new Promise(function (resolve) {
              return setTimeout(function () {
                return resolve(value);
              }, delayTime);
            }));

          case 3:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _delay.apply(this, arguments);
}

export default delay;